/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Klaviyo Back In Stock - proxy click to open form directly
  document.addEventListener('click', function(e) {
    var bisButton = e.target.closest('.js-klaviyo-bis-open');
    if (!bisButton) return;
    e.preventDefault();

    var isProductPage = window.location.pathname.includes('/products/');

    if (isProductPage) {
      // On product pages: proxy through the hidden trigger
      var wrapper = bisButton.closest('.product__submit__buttons');
      if (!wrapper) return;

      var trigger = wrapper.querySelector('.klaviyo-bis-trigger');
      if (!trigger) return;

      // Save scroll position before clicking
      var scrollX = window.scrollX;
      var scrollY = window.scrollY;

      // Make trigger temporarily clickable and click it
      trigger.style.setProperty('pointer-events', 'auto', 'important');
      trigger.click();

      // Restore scroll position
      requestAnimationFrame(function() {
        window.scrollTo(scrollX, scrollY);
      });

      // Wait for Klaviyo to inject its button container, then auto-click
      var attempts = 0;
      var interval = setInterval(function() {
        attempts++;
        var klaviyoContainer = document.getElementById('klaviyo-bis-button-container');
        if (klaviyoContainer) {
          var klaviyoBtn = klaviyoContainer.querySelector('button');
          if (klaviyoBtn) {
            clearInterval(interval);
            klaviyoBtn.click();
            trigger.style.setProperty('pointer-events', 'none', 'important');
            // Restore again after Klaviyo's button click
            requestAnimationFrame(function() {
              window.scrollTo(scrollX, scrollY);
            });
          }
        }
        if (attempts >= 30) {
          clearInterval(interval);
          trigger.style.setProperty('pointer-events', 'none', 'important');
        }
      }, 100);
    } else {
      // On non-product pages: open the form directly via Klaviyo API
      var formId = bisButton.getAttribute('data-klaviyo-form-id');
      if (formId && window.klaviyo && window.klaviyo.openForm) {
        window.klaviyo.openForm(formId);
      }
    }
  });

})();


/* ============================================================
   STICKY ADD TO CART BAR
   Shows a fixed bar at the bottom of the screen on product
   pages once the main ATC button scrolls out of view.
   ============================================================ */
(function () {
  if (!window.location.pathname.includes('/products/')) return;

  // Inject CSS
  var style = document.createElement('style');
  style.textContent = [
    '#ize-sticky-atc {',
    '  position: fixed;',
    '  bottom: 0;',
    '  left: 0;',
    '  right: 0;',
    '  z-index: 9999;',
    '  background: #f7f5f4;',
    '  border-top: 1px solid #e8e4dc;',
    '  padding: 12px 20px;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: space-between;',
    '  gap: 12px;',
    '  box-shadow: 0 -2px 12px rgba(0,0,0,0.08);',
    '  transform: translateY(100%);',
    '  transition: transform 0.3s ease;',
    '}',
    '#ize-sticky-atc.is-visible {',
    '  transform: translateY(0);',
    '}',
    '#ize-sticky-atc__title {',
    '  font-size: 14px;',
    '  font-weight: 600;',
    '  color: #9d6f67;',
    '  white-space: nowrap;',
    '  overflow: hidden;',
    '  text-overflow: ellipsis;',
    '  max-width: 45%;',
    '}',
    '#ize-sticky-atc__btn {',
    '  flex: 1;',
    '  max-width: 260px;',
    '  background: #9d6f67;',
    '  color: #fff;',
    '  border: none;',
    '  border-radius: 3px;',
    '  padding: 12px 20px;',
    '  font-size: 13px;',
    '  font-weight: 700;',
    '  letter-spacing: 0.08em;',
    '  text-transform: uppercase;',
    '  cursor: pointer;',
    '  white-space: nowrap;',
    '  transition: background 0.2s;',
    '}',
    '#ize-sticky-atc__btn:hover {',
    '  background: #8a5f58;',
    '}',
    '#ize-sticky-atc__btn:disabled {',
    '  opacity: 0.6;',
    '  cursor: not-allowed;',
    '}',
    '@media (max-width: 480px) {',
    '  #ize-sticky-atc__title { display: none; }',
    '  #ize-sticky-atc__btn { max-width: 100%; }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  // Build the bar HTML
  var bar = document.createElement('div');
  bar.id = 'ize-sticky-atc';
  bar.innerHTML = '<span id="ize-sticky-atc__title"></span><button id="ize-sticky-atc__btn">Add to Cart</button>';
  document.body.appendChild(bar);

  var stickyBtn = document.getElementById('ize-sticky-atc__btn');
  var stickyTitle = document.getElementById('ize-sticky-atc__title');
  var stickyBar = document.getElementById('ize-sticky-atc');

  // Populate product title
  var productTitle = document.querySelector('.product__title h1, .product__title, h1.product__title, [data-product-title], .product-single__title');
  if (productTitle) {
    stickyTitle.textContent = productTitle.textContent.trim();
  }

  // Find the main ATC button on the page
  function getMainAtcButton() {
    return document.querySelector(
      'form[action*="/cart/add"] button[type="submit"]:not(#ize-sticky-atc__btn), ' +
      '.product__submit__buttons button[name="add"]:not(#ize-sticky-atc__btn), ' +
      'button[name="add"]:not(#ize-sticky-atc__btn)'
    );
  }

  // Show/hide bar based on main button visibility
  function onScroll() {
    var mainBtn = getMainAtcButton();
    if (!mainBtn) return;
    var rect = mainBtn.getBoundingClientRect();
    var isOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;
    if (isOutOfView) {
      stickyBar.classList.add('is-visible');
      // Mirror disabled state
      stickyBtn.disabled = mainBtn.disabled;
    } else {
      stickyBar.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Clicking the sticky button submits the main form
  stickyBtn.addEventListener('click', function () {
    var mainBtn = getMainAtcButton();
    if (mainBtn && !mainBtn.disabled) {
      mainBtn.click();
    }
  });

})();
